<template>
  <div>
    <m-table
      :create-button="false"
      :page-model="pageModel"
      ref="table"
      title="鉴权记录（过期自动删除）"
      :rules="{}"
      title-key="id"
      resource="鉴权"
      border
    >
      <template v-slot:default>
        <el-table-column label="ID" prop="id" align="center" header-align="center" width="50"></el-table-column>
        <el-table-column label="用户ID" prop="user_id" align="center" header-align="center"></el-table-column>
        <el-table-column label="用户昵称" prop="user_name" align="center" header-align="center"></el-table-column>
        <el-table-column label="所在分组" prop="group" align="center" header-align="center"></el-table-column>
        <el-table-column label="过期时间" prop="timeout_at" align="center" header-align="center"></el-table-column>
        <el-table-column label="创建时间" prop="created_at" align="center" header-align="center"></el-table-column>
        <el-table-column
          label="秘钥"
          prop="auth_key"
          width="120"
          align="center"
          header-align="center"
        >
          <template slot-scope="{row}">
            <el-button
              type="warning"
              v-clipboard:copy="`${row.auth_key}`"
              v-clipboard:success="function(){$message({type:'success',message:'复制成功'})}"
            >复制秘钥</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" header-align="center">
          <template slot-scope="{row}">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="$refs.table.del(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </template>
      <template v-slot:search>
        <el-form :model="condition" ref="search">
          <el-row :gutter="5">
            <el-col :span="4">
              <el-form-item prop="user_name">
                <el-input v-model="condition.user_name" placeholder="过滤用户昵称" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="user_id">
                <el-input v-model="condition.user_id" placeholder="过滤用户ID" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="group">
                <el-input v-model="condition.group" placeholder="过滤分组" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                type="primary"
                @click="$refs.table.confirmSearch(condition)"
              ></el-button>
              <el-button icon="el-icon-refresh" @click="$refs.search.resetFields()"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </m-table>
  </div>
</template>

<script>
import MTable from "../../components/table/index";
import Record from "../../models/Record";
export default {
  components: { MTable },
  data: () => ({
    pageModel: new Record(),
    condition: {
      user_name: null,
      user_id: null,
      group: null
    }
  })
};
</script>

<style>
</style>